// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Box, Flex, Text, Button } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'

import Span from '@components/v21/common/span/Span'

// Styles
import styles from './HowItWorksWrapper.module.sass'

// Data
const data = [
  {
    id: 1,
    title: 'Pick your departure airport',
    description:
      'Set up your home airport & we will also include best offers from nearby airports',
    image: 'deals'
  },
  {
    id: 2,
    title: 'Get deal notifications via email',
    description:
      'We will send you deals based on your preferable email frequency',
    image: 'email'
  },
  {
    id: 3,
    title: 'Book the best deal',
    description:
      'You will get all flight details and a booking link to purchase your tickets fast and easy',
    image: 'departure'
  }
]

interface HowItWorksWrapperProps {
  redirectURL: string
}

const HowItWorksWrapper = ({ redirectURL }: HowItWorksWrapperProps) => {
  return (
    <Section padding={[0, 0, 32]}>
      <Text
        tagName="h2"
        variant="title-2"
        spacing={{ sm: 48 }}
        align="center"
        transform="capitalize"
      >
        How it works?
      </Text>

      <Flex flexDirection="column" rowGap={{ sm: 32 }} spacing={{ sm: 32 }}>
        {data.map((item) => (
          <HowItWorksCard key={item.id} {...item} />
        ))}
      </Flex>

      <Flex fullWidth justifyContent="center" id="experiences-anchor">
        <Button href={redirectURL} variant="yellow-sm-shadow" as={Link}>
          start now
        </Button>
      </Flex>
    </Section>
  )
}

export default HowItWorksWrapper

const HowItWorksCard = ({
  title,
  description,
  id,
  image
}: {
  title: string
  description: string
  id: number
  image: string
}) => {
  return (
    <Box
      padding={{ sm: [32, 24] }}
      className={styles.card}
      backgroundColor="white"
      borderRadius={{ sm: [16] }}
    >
      <Box
        backgroundColor="yellow"
        borderRadius={{ sm: [50] }}
        className={styles.tag}
      >
        <Flex center fullHeight fullWidth>
          <Span variant="body-1" fontWeight={700}>
            {id}
          </Span>
        </Flex>
      </Box>
      <Flex flexDirection="column" alignItems="center" rowGap={{ sm: 8 }}>
        <Image
          src={`/images/v25/illustrations/how-it-works/${image}.gif`}
          width={80}
          height={80}
          alt="Illustration"
        />
        <div>
          <Text
            tagName="h3"
            variant="body-2"
            align="center"
            transform="capitalize"
            fontWeight={700}
            spacing={{ sm: 16 }}
          >
            {title}
          </Text>
          <Text tagName="p" variant="body-1" align="center" textColor="grey-2">
            {description}
          </Text>
        </div>
      </Flex>
    </Box>
  )
}
